<template>
  <div
    class="tile"
    :class="{
      disabled: disabled,
      [`tile-${variant}`]: variant,
    }"
  >
    <!-- @slot Tile content -->
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    /**
     * Applies one of the style variants to the component.
     */
    variant: {
      type: String,
      default: 'minimal',
      validator: (value) => ['minimal', 'left-bordered', 'left-bordered-tab'].indexOf(value) !== -1,
    },

    /**
     * Tile does not react on mouse events.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>


.tile {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  padding: 1.5rem;
  background-color: #fff;
  border-radius: 2px;

  &.disabled {
    background-color: $gray-100;
    pointer-events: none;
    cursor: default;
  }

  &:focus,
  &.focus {
    border: 2px solid $cyan-500 !important;
  }

  &-minimal,
  &-left-bordered {
    &.active {
      &:after {
        content: escape-svg(url("data:image/svg+xml,<svg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'><path clip-rule='evenodd' d='m13.695 4.707-7.707 7.707-3.707-3.707 1.414-1.414 2.293 2.293 6.293-6.293z' fill='#242424' fill-rule='evenodd'/></svg>"));
        display: block;
        height: 16px;
        width: 16px;
        position: absolute;
        right: 8px;
        top: 8px;
      }
    }
  }

  &-left-bordered-tab {
    &.active {
      &:after {
        content: escape-svg(url("data:image/svg+xml,<svg fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path clip-rule='evenodd' d='m7.688 22.724-1.38-1.448 9.74-9.276-9.74-9.275 1.38-1.449 11.26 10.724z' fill='#242424' fill-rule='evenodd'/></svg>"));
        display: block;
        height: 24px;
        width: 24px;
        position: absolute;
        right: 32px;
        top: 32px;
      }
    }
  }

  &-minimal {
    border: 1px solid $gray-200;

    &.active {
      border-color: $gray-900;
    }

    &:hover,
    &.hover {
      border-color: $cyan-700;
    }
  }

  &-left-bordered,
  &-left-bordered-tab {
    border-bottom: 1px solid $gray-200;

    &.active {
      border-bottom: none;
      border-left: 4px solid $gray-900;
      padding-left: calc(1.5rem - 4px);

      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;

      &.focus,
      &:focus {
        padding-left: 1.5rem;
      }
    }

    &:hover,
    &.hover {
      background-color: $gray-000;
    }

    &.disabled {
      background-color: $gray-100;
    }
  }
}
</style>
